import { NewSignings } from '@sorare/marketplace/src/components/market/NewSignings';
import { primaryMarketFilters } from '@sorare/marketplace/src/searchCards/football/cardFilters';

import { PlayerDetails } from '@sorare/gameplay/src/components/player/PlayerDetails';

import { SelectedLeaderboardBanner } from 'components/searchCards/SelectedLeaderboardBanner';

const NewSigningsPage = () => {
  return (
    <NewSignings
      primaryMarketFilters={primaryMarketFilters}
      banner={<SelectedLeaderboardBanner />}
      PlayerDetailsComponents={PlayerDetails}
    />
  );
};

export default NewSigningsPage;
